import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { LoaderComponent } from './loader/loader.component';
import { PrimeNgModule } from '@app/prime-ng.module';

@NgModule({
    imports: [
        CommonModule,
        PrimeNgModule
    ],
    declarations: [LoaderComponent],
    exports: [
        LoaderComponent,
        PrimeNgModule,
        
    ],
})
export class SharedModule { }
